import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.Icon,
  title: 'Icon',
  category: ComponentCategory.General,
};
